const JOBS = {
  get: function() {
    var jobs = [
      {
        title: 'Full Stack Software Engineer',
        employer: 'adesso Netherlands',
        employerUrl: 'http://www.adesso.nl/',
        startDate: '2019-12-01T00:00:00',
        endDate: '',
        sector: 'IT & Services',
        location: 'Amsterdam, Netherlands',
        description: '',
        skills: [
          'Java',
          'Spring',
          'JPA',
          'Angular',
          'React',
          'JavaScript',
          'HTML',
          'CSS',
          'Jenkins',
          'SonarQube',
          'Docker',
          'SQL'
        ],
        highlights: []
      },
      {
        title: 'Senior Software Engineer Specialised in UI/UX',
        employer: 'Second Step Software Development LLC @ Yas Holding',
        employerUrl: 'http://www.yasholding.ae/',
        startDate: '2017-06-01T00:00:00',
        endDate: '2019-09-30T00:00:00',
        sector: 'IT & Services',
        location: 'Abu Dhabi, UAE',
        description: '',
        skills: [
          'Java',
          'GWT',
          'Angular',
          'JavaScript',
          'HTML',
          'CSS',
          'Jenkins',
          'SQL'
        ],
        highlights: [
          'Working closely with Solution Architects to design and develop the next generation environment and architecture, enabling the mobile product line',
          'Researching current technologies and solutions for combined mobile & web development, finalised by building both front and back-end for a working proof of concept mobile app for doctors',
          'Building an internal messaging system with support for pluggable SMS/Email senders, accessible through a clean and simple API'
        ]
      },
      {
        title: 'Senior Software Engineer',
        employer: 'ZCare Technologies LLC @ Yas Holding',
        employerUrl: 'http://www.yasholding.ae/',
        startDate: '2015-01-01T00:00:00',
        endDate: '2017-06-01T00:00:00',
        sector: 'Healthcare / IT & Services',
        location: 'Abu Dhabi, UAE',
        description: '',
        skills: ['Java', 'GWT', 'JavaScript', 'HTML', 'CSS', 'SQL'],
        highlights: [
          'Design and development of the UI framework built on top of Google Web Toolkit, enabling the development of complex web-based applications',
          'Re-write of a calendar component due to performance and alignment issues ended up as re-usable and performent control powering several other modules, partly thanks to the support of both a horizontal and vertical layout while having the time-awareness being a specialization of the base idea',
          'Designed and developed a robust persistent task runner, enabling the developer to just provide a task implementation and watch the magic happen. Ended up powering several CRON & triggered task runners'
        ]
      },
      {
        title: 'Software Engineer',
        employer: 'Maidis LLC @ Yas Holding',
        employerUrl: 'http://www.yasholding.ae/',
        startDate: '2010-11-01T00:00:00',
        endDate: '2015-01-01T00:00:00',
        sector: 'Healthcare',
        location: 'Al Ain, UAE',
        description: '',
        skills: ['C++', 'C#', 'MFC', 'WPF', 'SQL'],
        highlights: [
          'Requirement analysis, design and development of complex, data driven serverside software modules, alongside the occasional client-side development',
          'Training and mentoring co-workers and clients on the use and configuration of newly developed modules'
        ]
      },
      {
        title: 'Lecturer Programming & Research Coordinator',
        employer: 'Digital Arts and Entertainment',
        employerUrl: 'http://www.digitalartsandentertainment.com/',
        startDate: '2008-10-01T00:00:00',
        endDate: '2010-10-02T00:00:00',
        sector: 'Education',
        location: 'Kortrijk, Belgium',
        description: '',
        skills: ['C++', 'DirectX', 'OpenGL'],
        highlights: [
          'Lecturing throughout all three years of the program on topics as programming, software design and applied mathematics and physics',
          'Creating and maintaining course materials for all taught classes',
          'Holding practical hands-on lab sessions, up to 6 hours a week per student',
          'Mentoring students one-on-one for taught classes, as well as helping them develop a healthy and balanced work ethic'
        ]
      },
      {
        title: "Research Assistant for the 'Digital Entertainment' Project",
        employer: 'Digital Arts and Entertainment',
        employerUrl: 'http://www.digitalartsandentertainment.com/',
        startDate: '2008-01-01T00:00:00',
        endDate: '2008-10-01T00:00:00',
        sector: 'Education',
        location: 'Kortrijk, Belgium',
        description: '',
        skills: ['C++', 'DirectX', 'OpenGL'],
        highlights: [
          'Researching real-time procedural content generation techniques',
          'Developing small test cases as proof of concepts',
          'Exploring the possibilities and intrinsic differences between several existing technologies and frameworks, among which OpenGL, DirectX and XNA',
          'Assisting in practical hands-on lab sessions'
        ]
      },
      {
        title: 'Junior Software Engineer',
        employer: 'dZine.be',
        employerUrl:
          'https://www.barco.com/en/News/Press-releases/Barco-acquires-digital-signage-specialist-dZine.aspx',
        startDate: '2006-01-01T00:00:00',
        endDate: '2008-01-02T00:00:00',
        sector: 'Digital Signage',
        location: 'Kortrijk, Belgium',
        description: '',
        skills: ['C++', 'MFC', 'WindowsCE'],
        highlights: [
          'Developing features for the Windows based software products and configuring WindowsCE OS builds for the in-house developed mobile office hardware product line'
        ]
      }
    ];
    return jobs;
  }
};

export default JOBS.get();
